import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'
import Icon from '../components/Icon.jsx'

export default function About() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>About</span></nav>
      <header className="page-head">
        <h1>About Level Up Glass Supply</h1>
        <p>Factory-direct glass, supplied with care from Ravenhall, Victoria.</p>
      </header>

      <section className="prose">
        <p>
          With 15 years in the glazing industry, Level Up Glass Supply is a Melbourne-based supplier of
          premium frameless and semi-frameless shower screens, sliding wardrobe doors, over-bath systems,
          toughened glass panels and shower hardware — supplied factory-direct from our Ravenhall warehouse
          at affordable prices, with no middlemen.
        </p>
        <p>
          Every glass product we sell complies with the Australian safety standard for toughened glass
          (AS/NZS 2208), and our hardware is covered by a 2-year warranty against manufacturing defects.
        </p>

        <h2>Our range</h2>
        <ul className="prose-list">
          <li><Icon name="check" size={16} /> <strong>Frameless & semi-frameless shower screens</strong> — 10mm and 6mm toughened glass in corner, inline, sliding and over-bath configurations</li>
          <li><Icon name="check" size={16} /> <strong>Hardware & fittings</strong> — 6 finishes: Chrome, Matte Black, Brushed Nickel, Brushed Gold, Brushed Brass and Brushed Gunmetal</li>
          <li><Icon name="check" size={16} /> <strong>Glass panels</strong> — stocked sizes ready to ship (2100mm × 900mm standard)</li>
          <li><Icon name="check" size={16} /> <strong>Wardrobe doors</strong> — framed, semi-framed and frameless sliding doors, made to measure</li>
          <li><Icon name="check" size={16} /> <strong>Tools & accessories</strong> — silicone, seals, water bars and drill bits</li>
        </ul>

        <h2>Why buy from us</h2>
        <ul className="prose-list">
          <li><Icon name="check" size={16} /> 15 years in the glazing industry</li>
          <li><Icon name="check" size={16} /> Affordable, factory-direct pricing — better value on every order</li>
          <li><Icon name="check" size={16} /> 6mm & 10mm toughened safety glass options</li>
          <li><Icon name="check" size={16} /> Custom sizing available to suit your exact space</li>
          <li><Icon name="check" size={16} /> Delivery within 50 km of Ravenhall, or free warehouse pickup</li>
          <li><Icon name="check" size={16} /> Friendly, expert advice before you buy</li>
        </ul>

        <div className="contact-card">
          <h2>Visit or contact us</h2>
          <p><Icon name="pin" size={16} /> {SITE.address}</p>
          <p><Icon name="phone" size={16} /> <a href={SITE.phoneHref}>{SITE.phone}</a></p>
          <p><Icon name="mail" size={16} /> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></p>
          <p><Icon name="clock" size={16} /> {SITE.hours}</p>
          <p className="muted">{SITE.legalName} · {SITE.abn}</p>
        </div>
      </section>
    </main>
  )
}
